export const SET_HOME_BREADCRUMB_TRANSLATION =
  "SET_HOME_BREADCRUMB_TRANSLATION";
